<template lang="html">
  <div class="investment-reg__card-body">
    <div class="investment-reg__card-header">
      Добро пожаловать на курс Марафон инвестиций
    </div>

    <div class="investment-reg__card-text">
      На курсе тебя ждет увлекательное путешествие, где твоя главная цель —
      привлечь инвестиции и зайти на курс Миллион с Аязом! Твой первый шаг —
      заполнить анкету о себе :)
    </div>

    <UiButton @click="$emit('next', 'ProfilePage')">
      Перейти к анкете
    </UiButton>
  </div>
</template>

<script>
export default {
  name: 'GreetingPage'
};
</script>
